import ToastActionTypes from './toast-types'

export const startToastDisplay = data => ({
    type: ToastActionTypes.START_TOAST_DISPLAY,
    payload: data,
})

export const finishToastDisplay = data => ({
    type: ToastActionTypes.FINISH_TOAST_DISPLAY,
    payload: data,
})
